// extracted by mini-css-extract-plugin
export default {"circularSpinner":"circularSpinner__W4N7M"};